"use strict";
exports.__esModule = true;
exports.chart_bullet_comparative_measure_warning_stroke_Width = {
  "name": "--pf-chart-bullet--comparative-measure--warning--stroke--Width",
  "value": 2,
  "var": "var(--pf-chart-bullet--comparative-measure--warning--stroke--Width, 2)"
};
exports["default"] = exports.chart_bullet_comparative_measure_warning_stroke_Width;